// extracted by mini-css-extract-plugin
module.exports = {"normalIcon":"GroupRoles_normalIcon__3P228","noList":"GroupRoles_noList__oTTPZ","application":"GroupRoles_application__1gKV_"};